<template>
    <div>
        <div class="com-page-title">
            <div class="inner">{{ $route.meta.title }}</div>
        </div>
        <div class="com-card">
            <div class="com-card-title">在线护持</div>
            <div class="com-card-content">
                <div class="text-wrap">
                    <p>开设在线法缘护持通道，是盼助善动植万蕊心莲，共建人间净土。</p>
                    <br>
                </div>
                <van-list
                    v-model:loading="loading"
                    :finished="finished"
                    @load="getList"
                >
                    <ul class="com-list-grid">
                        <li v-for="lst in list" :key="lst.id" @click="nextStep(lst)">
                            <img :src="$joinImgPrefix(lst.picUrl)" alt="" />
                            <div class="text">
                                <p class="t1">{{ lst.name }}</p>
                                <!-- <div class="line van-hairline--bottom" /> -->
                                <!-- <p class="t2" v-if="lst.pid == 0">{{ lst.price == 0 ? '随喜金额' : `¥${lst.price}` }}</p>
                                <p class="t2" v-else-if="lst.pid == 2">¥50/对</p>
                                <p class="t2" v-else-if="lst.pid == 3">选择林木</p> -->
                            </div>
                        </li>
                    </ul>
                </van-list>
            </div>
        </div>
    </div>
</template>

<script>
    import { getUserInfo } from '@/utils/auth'
    import realRegisterTip from '@/utils/RealRegisterTip'
    export default {
        data () {
            return {
                userInfo: getUserInfo(),
                loading: false,
                finished: false,
                list: [],
                page: 1,
                limit: 10
            }
        },
        methods: {
            
            // 查询分类列表
            getList () {
                this.$faWuApi.fuTian.list({
                    page: this.page,
                    limit: this.limit
                }).then(res => {
                    if (res.success) {
                        const data = res.data
                        if (data.list.length < this.limit) {
                            this.finished = true
                        }

                        this.page ++
                        this.list = this.list.concat(data.list)
                        this.loading = false
                    } else {
                        this.$toast(res.errMessage)
                    }
                })
            },
            // 下一步
            nextStep (item) {
                // 已实名用户才能进入下一页
                if (this.userInfo.status == 1) {
                    this.$router.push({
                        path: 'futian/detail',
                        query: {
                            id: item.id
                        }
                    })
                } else {
                    realRegisterTip()
                }
            },
        },
        components: {
        }
    }
</script>